import SpeedManagePaneCustomizeItem from "./SpeedManagePaneCustomizeItem";

export default SpeedManagePaneCustomizeItem;
export { SpeedManagePaneCustomizeItem };
